import React from 'react';
import Input from './Fields/Input';
import Icon from './Icon';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  CENTER,
  MEDIA_QUERIES,
  TRANSPARENT,
  BASE_SPACING,
  DOVE_GRAY,
  ALTO,
} from '../styles';
import Wrapper from './Wrapper';
import { getTranslation } from './Text';

const s = StyleSheet.create({
  root: {
    width: '100%',
    borderColor: ALTO,
    borderWidth: '1px 0',
    borderStyle: 'solid',
  },
  wrapper: {
    height: 60,
    display: 'flex',
    alignItems: CENTER,
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: BASE_SPACING / 2,
    color: DOVE_GRAY,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      width: 25,
      height: 25,
    },
  },
  input: {
    backgroundColor: TRANSPARENT,
    borderColor: TRANSPARENT,
  },
  inputContainer: {
    marginBottom: 0,
  },
});

const Search = (props) => (
  <label className={css(s.root)}>
    <Wrapper __className={s.wrapper}>
      <Icon name="search" __className={s.icon} />
      <Input
        {...props}
        __inputClass={s.input}
        __containerClass={s.inputContainer}
        placeholder={getTranslation('app.filter.brackets')}
      />
    </Wrapper>
  </label>
);

export default Search;
